module.exports = __webpack_public_path__ + "static/media/icon_life.03a19ff3.svg";